const CURRENCY_EXPONENTS = { AUD: 2 };

export function minorDecimal(minor, currency) {
  const exponent = CURRENCY_EXPONENTS[currency];
  if (typeof minor !== "number" || !Number.isSafeInteger(minor) || minor < 0 || exponent == null) {
    return null;
  }
  let scale = 1;
  for (let step = 0; step < exponent; step += 1) {
    scale *= 10;
  }
  const places = String(scale).length - 1;
  const digits = String(minor).padStart(places + 1, "0");
  const whole = digits.slice(0, digits.length - places).replace(/^0+(?=\d)/, "");
  const fraction = digits.slice(digits.length - places);
  return `${whole}.${fraction}`;
}

export function documentCurrency(types) {
  if (!Array.isArray(types) || types.length === 0) {
    return null;
  }
  let code = null;
  for (const item of types) {
    const currency = item && item.currency;
    if (typeof currency !== "string" || currency.trim() === "") {
      return null;
    }
    if (code == null) {
      code = currency;
    } else if (code !== currency) {
      return null;
    }
  }
  return code;
}
